import { gql } from '@apollo/client'; // Needed for defining GraphQL queries

/**
 * Query to fetch product types available to the customer
 * Products include fuel types (95 Oktan, Diesel, etc.) and other items
 */
export const GET_PRODUCTS_DATA_QUERY = gql`
	query productsData($after: String, $before: String, $first: Int, $last: Int) {
		products(after: $after, before: $before, first: $first, last: $last) {
			nodes {
				id
				name
				shortName
				unit
			}
			pageInfo {
				endCursor
				hasNextPage
				hasPreviousPage
				startCursor
			}
		}
	}
`;